async function devtricker_process_emailLogin() {

    devtricker_dom_set_clearEmailLoginError();
    devtricker_dom_set_changeLoginEmailButtonToLoading();

    try {
        let form = devtricker_dom_get_emailLoginForm();
        await devtricker_ajax_post_customWpLogin(form);
        sessionStorage.clear();
        window.location.reload();
    } catch (error) {

        devtricker_dom_set_printEmailLoginError(error.message);
        devtricker_dom_set_changeLoginEmailButtonToInitial();
    }
}

async function devtricker_process_emailLoginPow() {
    
    devtricker_dom_set_clearEmailLoginError();

    devtricker_dom_set_changeLoginEmailButtonToGeneratingPow();

    const { pow, pass, duration } = await devtricker_proofOfWorkArgon2idWithWorker();

    devtricker_dom_set_changeLoginEmailButtonToLoading();

    try {
        let form = devtricker_dom_get_emailLoginForm();
        await devtricker_ajax_post_customWpLoginPow(form, pow, pass, duration);
        sessionStorage.clear();
        window.location.reload();
    } catch (error) {

        devtricker_dom_set_printEmailLoginError(error.message);
        devtricker_dom_set_changeLoginEmailButtonToInitial();
    }
}

async function devtricker_process_emailLoginPowBrute() {

    let form = devtricker_dom_get_emailLoginForm();
    attempts = 100;

    let successfulAttempts = 0;
    let attemptCount = 0;
    const startTime = performance.now();

    for (let i = 0; i < attempts; i++) {
        try {

            devtricker_dom_set_clearEmailLoginError();

            devtricker_dom_set_changeLoginEmailButtonToGeneratingPow();

            const { pow, pass, duration } = await devtricker_proofOfWorkArgon2id();

            devtricker_dom_set_changeLoginEmailButtonToLoading();

            await devtricker_ajax_post_customWpLoginPow(form, pow, pass, duration);

            successfulAttempts++;

            console.log(`Attempt ${i + 1}: Login successful`);
        } catch (error) {
            console.log(`Attempt ${i + 1}: Login failed - ${error.message}`);
        } finally {
            attemptCount++;
        }
    }

    const endTime = performance.now();
    const timeTaken = (endTime - startTime) / 1000;

    console.log(`Total attempts: ${attemptCount}`);
    console.log(`Successful logins: ${successfulAttempts}`);
    console.log(`Total time taken: ${timeTaken.toFixed(2)} seconds`);

}